import DialogLayout from './DialogLayout';

export default DialogLayout;
